import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form/immutable';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { Loading } from '../../../../loadbar/Loading';
import { LabeledText } from '../../../../form/LabeledText';
import { LabeledSelect } from '../../../../form/LabeledSelect';
import {
  clearEarthquake as clearEarthquakeAc,
  getEarthquake as getEarthquakeAc,
  getVolcano as getVolcanoAc,
  getTsunami as getTsunamiAc,
  getReferences as getReferencesAc,
  searchReferences as searchReferencesAc,
  searchVolcanoes as searchVolcanoesAc,
  createEarthquake as createEarthquakeAc,
  updateEarthquake as updateEarthquakeAc,
  searchTsunamis as searchTsunamisAc,
  getRegions as getRegionsAc,
  getCountries as getCountriesAc,
  getAreas as getAreasAc,
  getLocations as getLocationsAc,
  sortReferences as sortReferencesAc,
  sortTsunamis as sortTsunamisAc,
  sortVolcanoes as sortVolcanoesAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  toggleReferenceColumns as toggleReferenceColumnsAc,
  toggleTsunamiColumns as toggleTsunamiColumnsAc,
  toggleVolcanoColumns as toggleVolcanoColumnsAc,
} from '../../../../../redux/earthquakes/edit/earthquakeEditActions';
import { earthquakeEditModel, createInitialForm, formToJson } from './earthquakeEditModel';
import { LabeledCheckbox } from '../../../../form/LabeledCheckbox';
import { AssociatedVolcanoControl } from '../../../../form/AssociatedVolcanoControl';
import { AssociatedTsunamiControl } from '../../../../form/AssociatedTsunamiControl';
import { AssociatedReferenceControl } from '../../../../form/AssociatedReferenceControl';
import { CommentsEditor } from '../../../../form/CommentsEditor';
import { EditForm } from '../../../../form/EditForm';

const model = earthquakeEditModel.get('name');
const initialValues = earthquakeEditModel.get('initialValues');

class EarthquakeEditPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Earthquake Edit';
    const {
      match: { params: { id } },
      getEarthquake,
      getVolcano,
      getTsunami,
      getReferences,
      getRegions,
      getCountries,
      getAreas,
      getLocations,
      history,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getEarthquake({ id, history });
      getVolcano({ id, history });
      getTsunami({ id, history });
      getReferences({ id, history });
    }
    getLocations({ history });
    getRegions({ history });
    getAreas({ history });
    getCountries({ history });
    this.setState(state);
  }

  componentDidUpdate() {
    const { fetched, initializeForm, earthquake } = this.props;
    const { initialized } = this.state;
    if (!initialized) {
      if (fetched) {
        const form = createInitialForm(earthquake);
        initializeForm(form);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearEarthquake,
    } = this.props;
    clearEarthquake();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, earthquake,
    } = this.props;
    resetForm();
    // There seems to be a bug in react-redux-form. This needs to be called to set the original references.
    // change('.referenceIds', createInitialForm(earthquake).get('referenceIds'));
    change('', createInitialForm(earthquake));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    const { isAdd, initialized } = this.state;
    const {
      pristine,
      updating,
      volcano,
      tsunami,
      searchReferences,
      references,
      referenceSearching,
      referenceSearchResults,
      searchTsunamis,
      tsunamiSearching,
      tsunamiSearchResults,
      searchVolcanoes,
      volcanoSearching,
      volcanoSearchResults,
      regions,
      countries,
      areas,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      locations,
      volSort,
      sortVolcanoes,
      tsuSort,
      sortTsunamis,
      refSort,
      sortReferences,
      match: { params: { id } },
      history,
      createEarthquake,
      updateEarthquake,
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      earthquake,
      refVisibleColumns,
      tsuVisibleColumns,
      volVisibleColumns,
      toggleTsunamiColumns,
      toggleReferenceColumns,
      toggleVolcanoColumns,
    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }

    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const housesDescriptorsJs = housesDescriptors.toJS();

    return (

      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">{isAdd ? 'Add Earthquake' : `Edit Earthquake: ${id}`}</CardTitle>

            <EditForm
              model={model}
              hazardName="Earthquake"
              saving={updating}
              create={createEarthquake}
              update={updateEarthquake}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={earthquake}
            >

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Date and Location</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-2']} model=".year" label="Year" readOnly={updating} helpModalId="year" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".month" label="Month" readOnly={updating} helpModalId="month" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".day" label="Day" readOnly={updating} helpModalId="day" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".hour" label="Hour" readOnly={updating} helpModalId="hour" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".minute" label="Min" readOnly={updating} helpModalId="minute" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".second" label="Second" readOnly={updating} helpModalId="second" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".latitude" label="Latitude" readOnly={updating} helpModalId="eqLatitude" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".longitude" label="Longitude" readOnly={updating} helpModalId="eqLongitude" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-12']} model=".eqDepth" label="Depth" readOnly={updating} helpModalId="eqFocalDepth" />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={regions.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="regionCode" label="Region" readOnly={updating} filterable prependId helpModalId="region" />
                    <LabeledSelect childOptions={locations.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="locationName" label="Location" readOnly={updating} filterable addable helpModalId="eqLocName" />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="country" label="Country" helpModalId="eqCountry" readOnly={updating} filterable addable />
                    <LabeledSelect childOptions={areas.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="area" label="Area" helpModalId="eqArea" readOnly={updating} filterable addable />
                  </div>

                </CardBody>
              </Card>


              <Card>
                <CardBody>
                  <CardTitle tag="h2">Measurements</CardTitle>
                  <Card>
                    <CardBody>
                      <CardTitle>Magnitude</CardTitle>
                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-sm-2']} model=".eqMagUnk" label="UNK" readOnly={updating} helpModalId="eqUnkMag" />
                        <LabeledText formGroupClassName={['col-sm-2']} model=".eqMagMb" label="MB" readOnly={updating} helpModalId="eqMbMag" />
                        <LabeledText formGroupClassName={['col-sm-2']} model=".eqMagMs" label="MS" readOnly={updating} helpModalId="eqMsMag" />
                        <LabeledText formGroupClassName={['col-sm-2']} model=".eqMagMw" label="MW" readOnly={updating} helpModalId="eqMwMag" />
                        <LabeledText formGroupClassName={['col-sm-2']} model=".eqMagMfa" label="MFA" readOnly={updating} helpModalId="eqMfaMag" />
                        <LabeledText formGroupClassName={['col-sm-2']} model=".eqMagMl" label="ML" readOnly={updating} helpModalId="eqMlMag" />
                      </div>
                    </CardBody>
                  </Card>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-12']} model=".intensity" label="MMI Intensity" readOnly={updating} helpModalId="eqIntensity" />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Effects</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".deaths" label="Deaths" readOnly={updating} helpModalId="eqDeaths" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="deathsAmountOrder" label="Deaths Description" readOnly={updating} sorted={false} prependId helpModalId="eqDeathsDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".missing" label="Missing" readOnly={updating} helpModalId="eqMissing" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="missingAmountOrder" label="Missing Description" readOnly={updating} sorted={false} prependId helpModalId="eqMissingDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".injuries" label="Injuries" readOnly={updating} helpModalId="eqInjuries" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="injuriesAmountOrder" label="Injuries Description" readOnly={updating} sorted={false} prependId helpModalId="eqInjuriesDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".damageMillionsDollars" label="Damage ($Mil)" readOnly={updating} helpModalId="eqDamage" />
                    <LabeledSelect childOptions={damageDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="damageAmountOrder" label="Damage Description" readOnly={updating} sorted={false} prependId helpModalId="eqDamageDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDestroyed" label="Houses Destroyed" readOnly={updating} helpModalId="eqHousesDestroyed" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDestroyedAmountOrder" label="Houses Destroyed Description" readOnly={updating} sorted={false} prependId helpModalId="eqHousesDestroyedDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDamaged" label="Houses Damaged" readOnly={updating} helpModalId="eqHousesDamaged" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDamagedAmountOrder" label="Houses Damaged Description" readOnly={updating} sorted={false} prependId helpModalId="eqHousesDamagedDescription" />
                  </div>

                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Total Effects (Earthquake and Tsunami, Volcano, etc.)</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".deathsTotal" label="Total Deaths" readOnly={updating} helpModalId="eqTotalDeaths" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="deathsAmountOrderTotal" label="Total Deaths Description" readOnly={updating} sorted={false} prependId helpModalId="eqTotalDeathsDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".missingTotal" label="Total Missing" readOnly={updating} helpModalId="eqTotalMissing" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="missingAmountOrderTotal" label="Total Missing Description" readOnly={updating} sorted={false} prependId helpModalId="eqTotalMissingDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".injuriesTotal" label="Total Injuries" readOnly={updating} helpModalId="eqTotalInjuries" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="injuriesAmountOrderTotal" label="Total Injuries Description" readOnly={updating} sorted={false} prependId helpModalId="eqTotalInjuriesDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".damageMillionsDollarsTotal" label="Total Damage ($Mil)" readOnly={updating} helpModalId="eqTotalDamage" />
                    <LabeledSelect childOptions={damageDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="damageAmountOrderTotal" label="Total Damage Description" readOnly={updating} sorted={false} prependId helpModalId="eqTotalDamageDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDestroyedTotal" label="Total Houses Destroyed" readOnly={updating} helpModalId="eqTotalHousesDestroyed" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDestroyedAmountOrderTotal" label="Total Houses Destroyed Description" readOnly={updating} sorted={false} prependId helpModalId="eqTotalHousesDestroyedDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDamagedTotal" label="Total Houses Damaged" readOnly={updating} helpModalId="eqTotalHousesDamaged" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDamagedAmountOrderTotal" label="Total Houses Damaged Description" readOnly={updating} sorted={false} prependId helpModalId="eqTotalHousesDamagedDescription" />
                  </div>

                </CardBody>
              </Card>

              <AssociatedVolcanoControl
                model={model}
                volcano={volcano}
                volcanoSearching={volcanoSearching}
                volcanoSearchResults={volcanoSearchResults}
                searchVolcanoes={config => searchVolcanoes({ ...config, history })}
                sort={volSort}
                sortData={sortVolcanoes}
                helpModalId="eqVolcano"
                visibleColumns={volVisibleColumns}
                toggleColumns={toggleVolcanoColumns}
              />

              <AssociatedTsunamiControl
                model={model}
                tsunami={tsunami}
                searchTsunamis={config => searchTsunamis({ ...config, history })}
                tsunamiSearching={tsunamiSearching}
                tsunamiSearchResults={tsunamiSearchResults}
                sort={tsuSort}
                sortData={sortTsunamis}
                helpModalId="eqTsunami"
                visibleColumns={tsuVisibleColumns}
                toggleColumns={toggleTsunamiColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Comments</CardTitle>
                  <CommentsEditor model={model} readOnly={updating} />
                </CardBody>
              </Card>

              <AssociatedReferenceControl
                model={model}
                initialReferences={references}
                searchReferences={config => searchReferences({ ...config, history })}
                referenceSearching={referenceSearching}
                referenceSearchResults={referenceSearchResults}
                sort={refSort}
                sortData={sortReferences}
                visibleColumns={refVisibleColumns}
                toggleColumns={toggleReferenceColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Checks</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".flagDuplicate" label="Duplicate" />
                    <LabeledCheckbox inline model=".flagEpicenterChk" label="Epicenter Checked" />
                    <LabeledCheckbox inline model=".flagMagnitudeChk" label="Magnitude Checked" />
                    <LabeledCheckbox inline model=".flagEffectsChk" label="Effects Checked" />
                  </div>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Visibility</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".publish" label="Publish" />
                  </div>
                </CardBody>
              </Card>


              <div>
                <Button disabled={updating || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={updating || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={updating} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>

      </div>
    );
  }
}

EarthquakeEditPageUnwrapped.propTypes = {
  clearEarthquake: PropTypes.func.isRequired,
  getEarthquake: PropTypes.func.isRequired,
  getVolcano: PropTypes.func.isRequired,
  getTsunami: PropTypes.func.isRequired,
  searchVolcanoes: PropTypes.func.isRequired,
  createEarthquake: PropTypes.func.isRequired,
  updateEarthquake: PropTypes.func.isRequired,
  getReferences: PropTypes.func.isRequired,
  searchReferences: PropTypes.func.isRequired,
  earthquake: ImmutablePropTypes.map.isRequired,
  volcano: ImmutablePropTypes.map.isRequired,
  tsunami: ImmutablePropTypes.map.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  fetched: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  change: PropTypes.func.isRequired,
  referenceSearching: PropTypes.bool.isRequired,
  referenceSearchResults: ImmutablePropTypes.list.isRequired,
  tsunamiSearching: PropTypes.bool.isRequired,
  tsunamiSearchResults: ImmutablePropTypes.list.isRequired,
  searchTsunamis: PropTypes.func.isRequired,
  volcanoSearching: PropTypes.bool.isRequired,
  volcanoSearchResults: ImmutablePropTypes.list.isRequired,
  getRegions: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getAreas: PropTypes.func.isRequired,
  getLocations: PropTypes.func.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  areas: ImmutablePropTypes.list.isRequired,
  locations: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  sortVolcanoes: PropTypes.func.isRequired,
  volSort: ImmutablePropTypes.list.isRequired,
  sortTsunamis: PropTypes.func.isRequired,
  tsuSort: ImmutablePropTypes.list.isRequired,
  sortReferences: PropTypes.func.isRequired,
  refSort: ImmutablePropTypes.list.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,
  toggleReferenceColumns: PropTypes.func.isRequired,
  refVisibleColumns: ImmutablePropTypes.list.isRequired,
  toggleTsunamiColumns: PropTypes.func.isRequired,
  tsuVisibleColumns: ImmutablePropTypes.list.isRequired,
  toggleVolcanoColumns: PropTypes.func.isRequired,
  volVisibleColumns: ImmutablePropTypes.list.isRequired,
};

const defaultMap = Map();

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['earthquakeEditPage', 'fetchedRegions']),
    state.getIn(['earthquakeEditPage', 'fetchedCountries']),
    state.getIn(['earthquakeEditPage', 'fetchedAreas']),
    state.getIn(['earthquakeEditPage', 'fetchedLocations']),
  ];
  if (!isAdd) {
    fetchedCheck.push(
      state.getIn(['earthquakeEditPage', 'fetched']),
      state.getIn(['earthquakeEditPage', 'fetchedVolcano']),
      state.getIn(['earthquakeEditPage', 'fetchedTsunami']),
      state.getIn(['earthquakeEditPage', 'fetchedReferences']),
    );
  }

  const volcanoes = state.getIn(['earthquakeEditPage', 'volcano']);
  const tsunamis = state.getIn(['earthquakeEditPage', 'tsunami']);

  return {
    fetched: fetchedCheck.every(v => v),
    earthquake: state.getIn(['earthquakeEditPage', 'earthquake']),
    volcano: volcanoes.size ? volcanoes.get(0) : defaultMap,
    tsunami: tsunamis.size ? tsunamis.get(0) : defaultMap,
    references: state.getIn(['earthquakeEditPage', 'references']),
    pristine: state.get('forms')[model].$form.pristine,
    updating: state.getIn(['earthquakeEditPage', 'updating']),
    referenceSearching: state.getIn(['earthquakeEditPage', 'referenceSearching']),
    referenceSearchResults: state.getIn(['earthquakeEditPage', 'referenceSearchResults']),
    tsunamiSearching: state.getIn(['earthquakeEditPage', 'tsunamiSearching']),
    tsunamiSearchResults: state.getIn(['earthquakeEditPage', 'tsunamiSearchResults']),
    volcanoSearching: state.getIn(['earthquakeEditPage', 'volcanoSearching']),
    volcanoSearchResults: state.getIn(['earthquakeEditPage', 'volcanoSearchResults']),
    regions: state.getIn(['earthquakeEditPage', 'regions']),
    countries: state.getIn(['earthquakeEditPage', 'countries']),
    areas: state.getIn(['earthquakeEditPage', 'areas']),
    locations: state.getIn(['earthquakeEditPage', 'locations']),
    housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
    damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
    peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
    volSort: state.getIn(['earthquakeEditPage', 'volSort']),
    tsuSort: state.getIn(['earthquakeEditPage', 'tsuSort']),
    refSort: state.getIn(['earthquakeEditPage', 'refSort']),
    formData: state.getIn(['earthquakeEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['earthquakeEditPage', 'editConfirmationOpen']),
    refVisibleColumns: state.getIn(['earthquakeEditPage', 'refVisibleColumns']),
    tsuVisibleColumns: state.getIn(['earthquakeEditPage', 'tsuVisibleColumns']),
    volVisibleColumns: state.getIn(['earthquakeEditPage', 'volVisibleColumns']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  clearEarthquake: clearEarthquakeAc,
  getEarthquake: getEarthquakeAc,
  getVolcano: getVolcanoAc,
  searchVolcanoes: searchVolcanoesAc,
  createEarthquake: createEarthquakeAc,
  updateEarthquake: updateEarthquakeAc,
  getTsunami: getTsunamiAc,
  getReferences: getReferencesAc,
  searchReferences: searchReferencesAc,
  searchTsunamis: searchTsunamisAc,
  getRegions: getRegionsAc,
  getCountries: getCountriesAc,
  getAreas: getAreasAc,
  getLocations: getLocationsAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  initializeForm: volcanoLocation => actions.load(model, volcanoLocation),
  setPristine: () => actions.setPristine(model),
  sortVolcanoes: sortVolcanoesAc,
  sortTsunamis: sortTsunamisAc,
  sortReferences: sortReferencesAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  toggleReferenceColumns: toggleReferenceColumnsAc,
  toggleTsunamiColumns: toggleTsunamiColumnsAc,
  toggleVolcanoColumns: toggleVolcanoColumnsAc,
}, dispatch);

export const EarthquakeEditPage = connect(mapStateToProps, mapDispatchToProps)(EarthquakeEditPageUnwrapped);
